import React from 'react'
import { WaveAnimation } from './WaveAnimation';
import { HeaderWrapper, HeaderText } from './style/GlobalStyle';

export const Header = () => {
  return (
    <>
      <WaveAnimation />
      <HeaderWrapper>
        <HeaderText>TODO TODO TODO TODO TODO TODO TODO TODO TODO</HeaderText>
      </HeaderWrapper>
    </>
  );
}